import http from '@/utils/http.js'

export const apiRequest = (params) => {
  return http.request(params)
}
